import { Avatar } from 'antd';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { isEmpty } from 'lodash';
import { authState } from '../../../../app/auth/authSlice';
import { commonState } from '../../../../app/base/commonSlice';
import avatar from '../../../../assets/person-circle.svg';

interface UserMessageProps {
  data: any;
}

function UserMessage({ data }: UserMessageProps) {
  const { profile } = useSelector(authState);
  const { language } = useSelector(commonState);
  const profilePic = useMemo(() => profile?.image, [profile?.image]);
  let message;
  if (typeof data === 'string') {
    message = data;
  } else if (language === 'en') {
    message = data?.msg_contents_en;
  } else if (language === 'bn') {
    message = data?.msg_contents_bn;
  }
  return (
    <div>
      <div className="flex flex-row-reverse gap-4 chat-reply mt-8">
        <div>
          <Avatar
            src={
              isEmpty(profilePic)
                ? avatar
                : `data:image/jpeg;base64,${profilePic}`
            }
          />{' '}
        </div>
        <div className="p-4 rounded-md bg-[#ECECEC] dark:bg-[#1D1D1D]">
          {message}
        </div>
      </div>
    </div>
  );
}

export default UserMessage;
